module.exports = __webpack_public_path__ + "img/06_new2017_temp_s.11baffe1.png";